/**
 * AI.GEN lines=1-20
 * 城市列表 API
 */
import {
  AllAreaRequest,
  AllAreaResponse,
  CityTimeRequest,
  CityTimeResponse,
  UserCityListApiResponse,
} from './declare';
import { context } from '@/context';
import { Request } from '@/context/request';

const request: Request = context.request;
const host = '';

/**
 * 获取用户城市列表
 * @returns 城市列表响应
 */
export const apiDispatchCityUserCityList =
  async (): Promise<UserCityListApiResponse> => {
    return request.post(host + '/api/dispatch/city/userCityList', {});
  };

/**
 * AI.GEN lines=1-6
 * 获取商圈列表
 * @param params 请求参数
 * @param params.cityName 城市名称
 * @returns 商圈列表响应
 */
export const apiDispatchCityAllArea = async (
  params: AllAreaRequest,
): Promise<AllAreaResponse> => {
  return request.post(host + '/api/dispatch/city/all/area', params);
};

/**
 * AI.GEN lines=1-13
 * 获取城市时间信息
 * @param params 请求参数
 * @param params.cityName 城市名称
 * @returns 城市时间与时区信息
 */
export const apiDispatchCityTimeInfo = async (
  params: CityTimeRequest,
): Promise<CityTimeResponse> => {
  return request.post(host + '/api/dispatch/city/cityInfo', params);
};
